import { render, staticRenderFns } from "./billingDetails.vue?vue&type=template&id=a29e949a&scoped=true&"
import script from "./billingDetails.vue?vue&type=script&lang=js&"
export * from "./billingDetails.vue?vue&type=script&lang=js&"
import style0 from "./billingDetails.vue?vue&type=style&index=0&id=a29e949a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a29e949a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/workspace/ecommerce_h5_dev_front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('a29e949a', component.options)
    } else {
      api.reload('a29e949a', component.options)
    }
    module.hot.accept("./billingDetails.vue?vue&type=template&id=a29e949a&scoped=true&", function () {
      api.rerender('a29e949a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/main/billingDetails.vue"
export default component.exports